
(() => {
 const init=()=>{
   const source=document.querySelector('.wdlt-description-content, .product__description.mobile .full');
   const sizes=[...document.querySelectorAll('.wdlt-product-info .size-options')];
   if(!source||!sizes.length||document.querySelector('.wdlt-inline-measurements'))return;
   const clone=source.cloneNode(true);
   clone.querySelectorAll('br').forEach(br=>br.replaceWith('\n'));
   clone.querySelectorAll('p,div,li').forEach(el=>el.append('\n'));
   const lines=[...new Set(clone.textContent.split('\n').map(x=>x.trim()).filter(x=>/^(Size Reference\b|Measurements\b|Model (?:is|wears|height)\b)/i.test(x)))];
   if(!lines.length)return;
   const box=document.createElement('div');box.className='wdlt-inline-measurements';
   lines.forEach(line=>{const p=document.createElement('p');p.textContent=line;box.append(p);});
   sizes.at(-1).after(box);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

